var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAppGallery04931B782(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 563.557,
    height: 166.707,
    viewBox: "0 0 149.108 44.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.88 139.624)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 149.108,
    height: 44.108,
    x: -189.881,
    y: -139.624,
    rx: 7.154,
    ry: 7.233
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-177.544 -131.963) scale(.33901)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.2,
    height: 79.2,
    x: 0.54,
    y: 0.412,
    ry: 17.058,
    fill: "#e14459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.846 5.59a2.253 2.245 0 00-2.25 2.246 2.253 2.245 0 002.254 2.243 2.253 2.245 0 002.252-2.245V7.83a2.253 2.245 0 00-2.256-2.241zm40.302 0a2.253 2.245 0 00-2.25 2.246 2.253 2.245 0 002.255 2.243 2.253 2.245 0 002.252-2.245V7.83a2.253 2.245 0 00-2.257-2.241z",
    fill: "#c73148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.757 7.525c-.783.042-.744 1.18-.744 1.18 4.209 8.196 11.957 12.215 20.893 12.216 8.924-.013 16.749-4.077 20.952-12.261 0 0 .166-1.541-1.474-1.007-4.31 7.144-11.55 11.37-19.473 11.383-7.937.002-15.152-4.18-19.47-11.337-.28-.135-.503-.184-.684-.174zm28.48 31.854l-2.394 7.13-2.33-7.125h-2.275L44.91 49.75h1.771l2.4-6.809 2.396 6.809h1.786l3.665-10.365h-2.218l-2.335 7.125-2.394-7.13zm-12.716.003l-4.645 10.361h2.183l.897-2.006.064-.151h4.826l.946 2.157h2.243l-4.603-10.3-.04-.061zm33.642 0v10.355h2.111V39.383zm-60.529.002v10.369h2.14v-4.211h4.83v4.21h2.141V39.385h-2.14v4.183h-4.83v-4.183zm19.014.003v5.935c0 1.685-.85 2.585-2.397 2.585-1.554 0-2.41-.925-2.41-2.657v-5.857H20.7v5.929c0 2.917 1.65 4.589 4.523 4.589 2.9 0 4.563-1.704 4.563-4.675v-5.85zm31.006.004v10.354h7.963v-1.888h-5.853V45.29h3.891V43.4h-3.891V41.28h5.65v-1.888zm-22.227 2.614l1.526 3.472.104.239H34.82l.102-.239z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: -134.821,
    y: -115.375,
    transform: "scale(1.05355 .94917)",
    fontWeight: 400,
    fontSize: 16.179,
    fontFamily: "sans-serif",
    fill: "#fff",
    strokeWidth: 0.404
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -134.821,
    y: -115.375,
    style: {
      InkscapeFontSpecification: "'Source Sans Pro Semi-Bold'"
    },
    fontWeight: 600,
    fontFamily: "Source Sans Pro"
  }, "AppGallery")), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: -134.915,
    y: -132.535,
    transform: "scale(1.05355 .94917)",
    fontWeight: 400,
    fontSize: 9.753,
    fontFamily: "sans-serif",
    fill: "#fff",
    strokeWidth: 0.244
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -134.915,
    y: -132.535,
    style: {
      InkscapeFontSpecification: "'Source Sans Pro'"
    },
    fontFamily: "Source Sans Pro"
  }, "\u041E\u0422\u041A\u0420\u041E\u0419\u0422\u0415 \u0412"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppGallery04931B782);
export default __webpack_public_path__ + "static/media/icon_app-gallery.04931b78-2.c171d56a604f0f0035f6bb846f1177c4ba343d72c0358c71be9f4c33b9918d3f.svg";
export { ForwardRef as ReactComponent };